module.exports = __webpack_public_path__ + "static/media/custsat.1163f6ef.jpg";